import {
  jb_button_tertiary_css_default
} from "./chunk.TXHJT5H6.js";
import {
  o as o2
} from "./chunk.BLBOUOUQ.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  Linkable
} from "./chunk.TC6HXM2Y.js";
import {
  o
} from "./chunk.DJ2G5F2M.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  ButtonElement
} from "./chunk.ALE4QRAM.js";
import {
  attachInterestEvents
} from "./chunk.AHMM4X2O.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-button-tertiary/jb-button-tertiary.ts
var JbButtonTertiary = class extends Initiable(ButtonElement(Linkable(i))) {
  constructor() {
    super(...arguments);
    this._hovering = false;
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.hasUpdated) this._syncInterestEvents();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this._detachInterestEvents?.();
    this._detachInterestEvents = void 0;
    this._interestTarget = void 0;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    this._syncInterestEvents();
  }
  _getAnimationName() {
    switch (this.arrowDirection) {
      case "up":
        return "move_up";
      case "right":
        return "move_right";
      case "down":
        return "move_down";
      default:
        return "move_right";
    }
  }
  /** Renders <a> or <button> depending on `link`, so the listeners follow whichever is current. */
  _syncInterestEvents() {
    if (this._activeElement === this._interestTarget) return;
    this._detachInterestEvents?.();
    this._interestTarget = this._activeElement;
    this._detachInterestEvents = attachInterestEvents(this._activeElement);
  }
  render() {
    const classes = {
      inactive: this.inactive,
      inverted: this.inverted,
      hover: this.forceHover || this._hovering,
      [`${this.arrowDirection}`]: this.arrowDirection
    };
    return this.link?.href ? b`<a
          data-linkable
          part="action"
          aria-label=${o2(this.accessibleLabel)}
          class=${e2(classes)}
          @interest=${() => {
      this._hovering = true;
    }}
          @loseinterest=${() => {
      this._hovering = false;
    }}
        >
          <slot>${this.text ? o(this.text) : A}</slot>
          <jb-icon
            iconName="material:east"
            .commonAnimation=${this._getAnimationName()}
            class="${e2({ hover: this.forceHover || this._hovering })}"
          ></jb-icon>
        </a>` : b`<button
          ?disabled=${this.inactive}
          part="action"
          aria-label=${o2(this.accessibleLabel)}
          class=${e2(classes)}
          @interest=${() => {
      this._hovering = true;
    }}
          @loseinterest=${() => {
      this._hovering = false;
    }}
        >
          <slot>${this.text ? o(this.text) : A}</slot>
          <jb-icon
            iconName="material:east"
            .commonAnimation=${this._getAnimationName()}
            class="${e2({ hover: this.forceHover || this._hovering })}"
          ></jb-icon>
        </button>`;
  }
};
JbButtonTertiary.styles = [reset_css_default, jb_button_tertiary_css_default];
JbButtonTertiary.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n()
], JbButtonTertiary.prototype, "accessibleLabel", 2);
__decorateClass([
  n()
], JbButtonTertiary.prototype, "arrowDirection", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonTertiary.prototype, "forceHover", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonTertiary.prototype, "inactive", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonTertiary.prototype, "inverted", 2);
__decorateClass([
  n()
], JbButtonTertiary.prototype, "name", 2);
__decorateClass([
  n()
], JbButtonTertiary.prototype, "text", 2);
__decorateClass([
  e("a, button")
], JbButtonTertiary.prototype, "_activeElement", 2);
__decorateClass([
  r()
], JbButtonTertiary.prototype, "_hovering", 2);
JbButtonTertiary = __decorateClass([
  customElement("jb-button-tertiary")
], JbButtonTertiary);

export {
  JbButtonTertiary
};
